import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { BigPicklistInput } from 'src/Packages/FacetDesign/Components/BigPicklistInput';
import { overrideReadOnly } from 'src/Packages/FacetRest/FacetDesignOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('destinationAccountId', {
    _component: () => BigPicklistInput,
    _customProps: {
      alignSelf: 'center',
      flex: 1,
    },
  }, overrideReadOnly);
